module.exports = __webpack_public_path__ + "img/down-neimeng3.9e8d50c7.jpg";